<template>
  <v-card class="mx-auto text-center" color="grey lighten-4" max-width="600">
    <v-card-title class="teal ligten-4">
      <span class="headline white--text"
        >Welcome to the DeltaCert control panel.</span
      >
    </v-card-title>

    <v-row class="mb-6" align="centre">
      <v-col>
        <span class="display-2 font-weight-black">{{ this.stats.total }}</span>
        <strong>Certificate{{ this.stats.total === 1 ? "" : "s" }}</strong>
      </v-col>
      <v-col>
        <span class="display-2 font-weight-black">{{
          this.stats.uniqueCustomers
        }}</span>
        <strong
          >Customer{{ this.stats.uniqueCustomers === 1 ? "" : "s" }}</strong
        >
      </v-col>
    </v-row>

    <v-divider class="my-2"></v-divider>
    <v-icon class="mr-2" small>
      mdi-account
    </v-icon>

    <span class="caption grey--text font-weight-light"
      >Logged in as <strong>{{ this.user.user }}</strong></span
    >
  </v-card>
</template>

<script>
import session from "../api/session";
export default {
  name: "home",
  data() {
    return {
      stats: {},
      user: {}
    };
  },
  created() {
    session.get("/api/cert/stats/").then(request => {
      this.stats = request.data;
    });
    session.get("/api/user/").then(request => {
      this.user = request.data;
    });
  }
};
</script>
